import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { map } from 'rxjs/operators';
import { SiteContext, Currency } from './../model';
import { Router } from '@angular/router';
import Constants from '../pages/checkout/utils/Constants';
import { environment } from 'src/environments/environment';

export interface UrlState {
  currentUrl: string;
  flag: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AppContext {
  isCurrencyChanged: BehaviorSubject<boolean>;
  selectedCurrencyCode: BehaviorSubject<string>;
  siteContext$: BehaviorSubject<SiteContext | null>;
  currency?: Currency;
  searchKey = null;
  private urlStateSubject = new BehaviorSubject<UrlState>({ currentUrl: '', flag: false });
  urlState$ = this.urlStateSubject.asObservable();

  hmt_header_link_icons = [
    { title: "Hotels", link: "https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/review.png" },
    { title: "Flights", link: "https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/google-flights.png" },
    { title: "Holiday Packages", link: "https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/customer.png" },
    { title: "Villas", link: "https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/home.png" },
    { title: "Experiences", link: "https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/customer.png" },
    { title: "Blogs", link: "https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/blog.png" }
  ]

  _currencyList: Currency[] = [
    { code: 'USD', symbol: '$' },
    { code: 'EUR', symbol: '€' },
    { code: 'INR', symbol: '₹' },
    { code: 'CAD', symbol: 'C$' },
    { code: 'AED', symbol: 'د.إ' },
    { code: 'PHP', symbol: '₱' },
    { code: 'BHD', symbol: 'د.ب' },
    { code: 'SAR', symbol: 'ر.س' },
    { code: 'OMR', symbol: 'ر.ع.' },
    { code: 'QAR', symbol: 'ر.ق' },
    { code: 'GBP', symbol: '£' },
    { code: 'MUR', symbol: 'MUR' },
    { code: 'SEK', symbol: 'SEK' },
    { code: 'AUD', symbol: 'Au$' }
  ]

  _joycurrencyList: Currency[] = [
    { code: 'USD', symbol: 'US$' },
    { code: 'EUR', symbol: '€' },
    { code: 'INR', symbol: '₹' },
    { code: 'CAD', symbol: 'CA$' },
    { code: 'AED', symbol: 'د.إ' },
    { code: 'PHP', symbol: '₱' },
    { code: 'BHD', symbol: 'د.ب' },
    { code: 'SAR', symbol: 'ر.س' },
    { code: 'OMR', symbol: 'ر.ع.' },
    { code: 'QAR', symbol: 'ر.ق' },
    { code: 'GBP', symbol: '£' },
    { code: 'MUR', symbol: 'MUR' },
    { code: 'SEK', symbol: 'SEK' },
    { code: 'AUD', symbol: 'AU$' }
  ]

  siteName: any;
  siteAccountId!: string;
  pageTitlePrefix!: string;
  querystring: string | undefined;
  context!: SiteContext;
  currencyChangeonDetails$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(false);
  nationality$: BehaviorSubject<any>;

  constructor(private http: HttpClient, private router: Router) {
    this.isCurrencyChanged = new BehaviorSubject<boolean>(false);
    this.selectedCurrencyCode = new BehaviorSubject<string>("");
    this.siteContext$ = new BehaviorSubject<SiteContext | null>(null);
    this.nationality$ = new BehaviorSubject<any>(null);
  }
  // Methd to update the values (current URL and flag)
  updateUrlState(url: string, flag: boolean): void {
    this.urlStateSubject.next({ currentUrl: url, flag: flag });
  }

  private dataSubject = new BehaviorSubject<any>(null);
  data$ = this.dataSubject.asObservable();
  updateData(data: any) {
    this.dataSubject.next(data);
  }

  async getNationality(siteContext: SiteContext) {
    try {
      let nationality = "US";
      let countryOfResidence = "US";

      if (
        siteContext.name != 'HostMyTrips') {
        nationality = 'US';
        countryOfResidence = 'US';
        environment.countryOfResidence = countryOfResidence;
        environment.nationality = nationality;
      }

      if (siteContext.name == 'HostMyTrips') {
        nationality = 'IN';
        countryOfResidence = 'IN';
        environment.countryOfResidence = nationality;
        environment.nationality = countryOfResidence;
      }
      if (siteContext.name == '30Sundays') {
        nationality = 'IN';
        countryOfResidence = 'IN';
        environment.countryOfResidence = nationality;
        environment.nationality = countryOfResidence;
      }
      if (siteContext.name == 'onyxum') {
        nationality = 'AM';
        countryOfResidence = 'AM';
        environment.countryOfResidence = countryOfResidence;
        environment.nationality = nationality;
      }

      let nationalityAndCountryOfResidence = {
        nationality: nationality,
        countryOfResidence: countryOfResidence
      }
      this.nationality$.next(nationalityAndCountryOfResidence);
    }
    catch (err) {
      console.error("Error in getNationality: ");
      console.error(err);
    }
  }

  getContext(): Observable<SiteContext> {
    this.querystring = '?';

    const url: URL = new URL(window.location.href);
    const params: URLSearchParams = url.searchParams;
    if (params.has('accountId') && params.has('channelId')) {
      const accountId = params.get('accountId');
      const channelId = params.get('channelId');
      this.querystring = '?channelId=' + channelId + '&accountId=' + accountId;
    }
    else if (params.has('context')) {
      const context = params.get('context');
      this.querystring = '?context=' + context;
    }
    else if (typeof window.location.search !== undefined && window.location.search != null) {
      this.querystring = '?' + window.location.search
    }

    return this.http.get<SiteContext>(`api/context${this.querystring}`)
      .pipe(map(res => {
        this.getNationality(res);
        this.siteContext$.next(res);
        if (this._isSessionStorageEnable) {
          const str = JSON.stringify(res);
          sessionStorage.setItem("SiteContext", str);
          this.siteName = res.name
          this.siteAccountId = res.accountId
          this.context = res;
          let sessionCurrency = sessionStorage.getItem('currency');
          if (sessionCurrency && this.getCurrency(sessionCurrency)) {
            this.currency = this.getCurrency(sessionCurrency);
          } else if (res.defaultCurrencyCode && this.getCurrency(res.defaultCurrencyCode)) {
            this.currency = this.getCurrency(res.defaultCurrencyCode);
            sessionStorage.setItem('currency', res.defaultCurrencyCode);
          } else {
            this.currency = this.getCurrency('USD');
            sessionStorage.setItem('currency', 'USD');
          }
          this.pageTitlePrefix = res.displaySetting.pageTitlePrefix;
          const currentUrl = this.router.url;
          if (this.context?.externalHomePage && currentUrl == '/') {
            window.location.href = this.context?.externalHomePage;
          }
        }
        return res;
      }));
  }

  // getCurrencySymbol(currency: string): string | undefined {
  //   const currencyItem = this._currencyList.find(item => item.code === currency);
  //   return currencyItem ? currencyItem.symbol : undefined;
  // }


  createSession(): Observable<SiteContext> {
    // const qparm = window.location.search;
    // if(qparm !== undefined && qparm.indexOf("update=true")===-1 && this._isSessionStorageEnable) {
    //   const str = sessionStorage.getItem("SiteContext");
    //   if(str){
    //      const context =  JSON.parse(str);
    //      this.siteContext$.next(context);
    //      return of(context);
    //   }
    // }
    return this.getContext();
  }


  setContext(channelId: any, accountId: any): Observable<SiteContext> {
    return this.http.get<SiteContext>(`api/context?channelId=${channelId}&accountId=${accountId}`)
      .pipe(map(res => {
        this.siteContext$.next(res);
        if (this._isSessionStorageEnable) {
          const str = JSON.stringify(res);
          sessionStorage.setItem("SiteContext", str);
        }
        return res;
      }));
  }


  getCurrencyList(): Observable<Currency[]> {
    return of(this._currencyList);
  }

  getCurrency(currencyCode: string) {
    if (this.context.name !== Constants.SiteNames.joy) {
      return this._currencyList.find(c => c.code === currencyCode);
    }
    else {
      return this._joycurrencyList.find(c => c.code === currencyCode);
    }
  }
  setCurrency(currencyCode: string) {
    this.currency = this.getCurrency(currencyCode);
    if (this._isSessionStorageEnable) {
      sessionStorage.setItem('currency', currencyCode);
    }
  }

  get _isSessionStorageEnable() {
    return typeof sessionStorage !== "undefined";
  }

  getCssVariableValue(variableName: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  }

}
